export default class Token{

    static get(){
        return window.jwtToken;
    }

    static store(token){
        window.jwtToken = token;
    }

    static clear(){
        delete window.jwtToken;
    }

    static has(){
        return !!Token.get();
    }

}
